import React, { useEffect, useState } from 'react';
import { SingleLink } from '../component/Main/Res/BaseButton';
import { uuid, getKey } from './ItemTools'
import { Pagination } from '../component/Main/Res/Pagination';
import { SingleInput, SingleSelect, SingleText } from '../component/Main/Res/BaseInput';
import { DatePickerInput } from 'rc-datepicker';
import { PlayerHistoryDate } from '../component/Main/Content/MyStat/Player/PlayerHistoryDate';

export class TableListTitle {
    constructor(name, size) {
        this.name = name
        this.size = size
    }

    fromJson(jsonDate) {
        this.name = jsonDate.name
        this.size = jsonDate.size
    }

    getTH() {
        return setTH({ name: this.name, size: this.size })
    }
}

export function setTH({ name, size }) {
    return <th className={"text-center sorting col-sm-" + size} key={getKey({})}>{name}</th>
}

export function setTD({ content, color = "default", isEdit = false, id, action, actionKey, actionVal, align = "center" }) {
    if (color === undefined)
        color = "default"

    function toAction(e) {
        action(actionKey, actionVal)
    }
    return <td className={"text-" + align} key={getKey({})}>
        {
            isEdit ?
                <SingleInput val={content} action={action} id={id} size={12} />
                :
                action === undefined ? <span className={"text-" + color}>{content}</span> :
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a onClick={e => toAction(e)} className={"text-" + color}>{content}</a>
        }
    </td>
}
export function setTDFirst({ content, bgcolor }) {
    return <td className="text-center" bgcolor={bgcolor} key={getKey({})}>
        <span >{content}&nbsp;</span>
    </td>

}

export function setTDSelect({ content, attr = [], v, n, color = "default", id, action, hasBlank = true }) {
    if (color === undefined)
        color = "default"
    return <td className="text-center" key={getKey({})}>
        <SingleSelect val={content} attr={attr} v={v} n={n} hasBlank={hasBlank} action={action} id={id} size={12} />
    </td>
}

export function setTDDate({ content, color = "default", isEdit = false, id, action, errAction }) {
    if (color === undefined)
        color = "default"
    return <td className="text-center" key={getKey({})}>
        {
            isEdit ?
                <PlayerHistoryDate id={id} date={content} action={action} errAction={errAction} />
                :
                <span className={"text-" + color} >{content}&nbsp;</span>
        }
    </td>
}

export function setDatePicker({ content, id, action }) {
    function onChange(jsDate, dateString) {
        // console.log(jsDate)
        // console.log(dateString)
        // console.log(content)
        action(id, jsDate)
    }
    return <DatePickerInput
        displayFormat='YYYY/MM/DD'
        returnFormat='YYYY-MM-DD'
        onChange={onChange}

        value={content}
        className='my-react-component'
        style={{ fontSize: '0px', paddingLeft: '0px' }}
        small={false}
    />
}

export function setTDLink({ link, content, key, val }) {
    return <td className="text-center" key={getKey({})}>
        <SingleLink link={link} name={content} Key={key} val={val}  ></SingleLink>&nbsp;
    </td>
}

export function getBlankTD({ len }) {
    var arr = []
    for (let index = 0; index < len; index++) {
        arr.push(setTDFirst({ content: "" }))
    }
    return <tr role="row" key={getKey({})}>
        {
            arr.map(obj => {
                return obj
            })
        }
    </tr>
}
export function getBlankTR({ len, bgcolor }) {
    return <tr role="row" height="10" key={getKey({})}>
        <td colSpan={len} bgcolor={bgcolor}></td>
    </tr>
}

export function ListBox({ row = 4, lt = 10, lb, srl, count, page, sp, searchItem }) {
    const [list_obj, set_list_obj] = useState({})
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit, set_limit] = useState(lt)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    // useEffect(() => {
    //     if (list !== undefined && mList !== list) {
    //         seList(list)
    //         setStart((page - 1) * limit + 1)
    //         setEnd((page - 1) * limit + list.length)
    //         // setItemList(setTableList(list))
    //         setPage(page)
    //     }

    // }, [list, count])

    useEffect(() => {
        if (lb !== undefined && lb !== list_obj) {
            set_list_obj(lb)
            setStart((page - 1) * limit + 1)
            if (lb.contents !== undefined) {
                // var clen = 0
                // lb.contents.forEach(item => {
                //     if (item.length > 0)
                //         clen++
                // })
                // // setEnd((page - 1) * limit + list_obj.contents.length)
                // setEnd((page - 1) * limit + clen)
                if (lb.contents.length < limit) {
                    setEnd((page - 1) * limit + lb.contents.length)
                } else {
                    setEnd((page) * limit)
                }

            } else {
                setEnd((page - 1) * limit)
            }
            setPage(page)
        }
        if (count !== mCount) {
            setCount(count)
        }

        if (lt !== limit) {
            set_limit(lt)
            console.log("limit")
            console.log(lt)
        }
    }, [lb, lt, count, list_obj])

    useEffect(() => {
        console.log("TableListTitle list_obj")
        // var len = 0;
        var len = limit
        try {
            // console.log(list_obj.contents)
            // console.log(list_obj.contents.length)
            if (list_obj.contents !== undefined)
                len = list_obj.contents.length
        } catch (e) { }
        var itemList = []
        for (var i = 0; i < len; i++) {
            // try {
            //     if (list_obj.contents !== undefined) {
            //         console.log("list_obj.contents[i].length" + i)
            //         console.log(list_obj.contents[i].length)
            //     }
            // } catch (e) {
            //     console.log(e)
            // }
            if (list_obj.contents !== undefined && list_obj.contents[i] !== undefined) {
                if (list_obj.contents[i].length === 0) {
                    itemList.push(getBlankTR({ len: row, bgcolor: "grey" }))
                } else if (list_obj.contents[i] !== undefined) {
                    itemList.push(<tr role="row" key={getKey({})}>
                        {
                            list_obj.contents[i].map(obj => {
                                return obj
                            })
                        }
                    </tr>)
                }
            } else {
                itemList.push(getBlankTD({ len: row }))
            }
        }
        setItemList(itemList)
    }, [list_obj])


    function sPage(p) {
        console.log("pagechange" + p)
        console.log(searchItem)
        if (p !== page) {
            sp({ page: p, searchItem })
            setPage(p)
        }
    }

    // if (itemList.length === 0) {
    //     return (<></>)
    // } else {
    //console.log(managerList)
    return (
        <div id="editable_wrapper" className="form-inline dt-bootstrap">
            <div className="row">
                <div className="col-sm-12">
                    <table className="table table-striped table-bordered table-hover  dataTable">
                        <thead>
                            <tr role="row">
                                {
                                    list_obj.titles === undefined ? <></> :
                                        list_obj.titles.map(obj => {
                                            return obj.getTH()
                                        })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                itemList.map((item) => (
                                    item
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
            }
        </div>
    )
}

// }
